import { ItemConnectionSort } from '../../graphql/types';
import { PriceViewMode } from '../../components/GeneralAdsPage/types';
import { BUILDING_TYPE_ID } from './constants';

export type PriceViewOption = {
  id: PriceViewMode;
  translationKey: string;
};

export type CategoryPriceViewConfig = {
  modes: PriceViewOption[];
  detect: (
    sort: ItemConnectionSort,
    prev?: PriceViewMode | null
  ) => PriceViewMode;
};

export const CATEGORY_PRICE_VIEW_CONFIG: Record<
  string,
  CategoryPriceViewConfig
> = {
  [BUILDING_TYPE_ID.AREA]: {
    modes: [
      {
        id: PriceViewMode.PerAcre,
        translationKey: 'new_search.price_per_acre'
      },
      { id: PriceViewMode.PerArea, translationKey: 'new_search.price_per_area' }
    ],
    detect: (sort: ItemConnectionSort, prev?: PriceViewMode | null) => {
      switch (sort) {
        case ItemConnectionSort.PricePerAreAsc:
        case ItemConnectionSort.PricePerAreDesc:
          return PriceViewMode.PerAcre;
        case ItemConnectionSort.PriceAsc:
        case ItemConnectionSort.PriceDesc:
          return PriceViewMode.PerArea;
        default:
          return prev ?? PriceViewMode.PerArea;
      }
    }
  }
};
